<template>
  <section class="company-profile">
    <div class="container profile-container">
      <div class="profile-text-content">
        <h2 class="main-title">{{ $t("companyProfile.titleZh") }}</h2>
        <p class="sub-title">{{ $t("companyProfile.titleEn") }}</p>
        <p class="profile-paragraph">{{ $t("companyProfile.p1") }}</p>
        <p class="profile-paragraph">{{ $t("companyProfile.p2") }}</p>
        <p class="profile-paragraph">{{ $t("companyProfile.p3") }}</p>
      </div>
      <div class="profile-image-wrapper">
        <img
          :src="profileImage"
          :alt="$t('companyProfile.imageAlt')"
          class="profile-image"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CompanyProfile",
  data() {
    return {
      // Use a placeholder or an actual image URL.
      // For local images: profileImage: require('@/assets/your-profile-image.jpg')
      profileImage:
        "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&fm=jpg&ixlib=rb-4.1.0&q=80&w=1400",
    };
  },
};
</script>

<style scoped>
.company-profile {
  padding: 100px 0;
  background-color: #f8f9fa; /* Light gray background to separate sections */
}

.container.profile-container {
  /* More specific selector */
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center; /* Align items vertically center */
  gap: 80px; /* Increase space between text and image */
}

.profile-text-content {
  flex: 1.5; /* Give more space to text */
  line-height: 1.7; /* From image, text seems to have good line spacing */
}

.main-title {
  font-size: 2.5em; /* 增大标题 */
  color: #1a1a2e; /* 更深的深蓝色 */
  margin-bottom: 0px;
  font-weight: 700;
  line-height: 1.2;
}

.sub-title {
  font-size: 1.25em; /* 缩小副标题 */
  color: #007bff; /* 使用主题蓝色作为强调色 */
  font-weight: 600;
  margin-top: 8px;
  margin-bottom: 30px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.profile-paragraph {
  font-size: 1.05em; /* 稍微加大正文 */
  color: #4a5568; /* 稍微柔和的深灰色 */
  line-height: 1.8;
  margin-bottom: 24px;
  text-align: justify;
}

.profile-image-wrapper {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.profile-image-wrapper::before {
  content: "";
  position: absolute;
  top: -15px;
  left: -15px;
  bottom: 15px;
  right: 15px;
  background-color: #e2e8f0;
  border-radius: 20px;
  z-index: 0;
  transform: rotate(-3deg);
  transition: transform 0.4s ease;
}

.profile-image-wrapper:hover::before {
  transform: rotate(-1deg);
}

.profile-image {
  max-width: 100%;
  height: auto;
  border-radius: 20px; /* 增大圆角 */
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12); /* 加深阴影 */
  position: relative;
  z-index: 1;
  transition: transform 0.4s ease;
}

.profile-image-wrapper:hover .profile-image {
  transform: translateY(-5px);
}

/* Responsive Adjustments */
@media (max-width: 992px) {
  .container.profile-container {
    flex-direction: column;
    align-items: center; /* Center items when stacked */
  }
  .profile-text-content {
    order: 2; /* Text below image on small screens if desired, or 1 for text above */
    margin-bottom: 30px; /* Space when stacked */
    text-align: left; /* Keep text left aligned */
  }
  .main-title,
  .sub-title {
    text-align: center;
  }
  .profile-image-wrapper {
    order: 1; /* Image above text */
    width: 80%;
    margin-bottom: 30px;
  }
}

@media (max-width: 768px) {
  .main-title {
    font-size: 2em;
  }
  .sub-title {
    font-size: 1.4em;
  }
  .profile-paragraph {
    font-size: 0.95em;
  }
  .profile-image-wrapper {
    width: 90%;
  }
}
</style>
